import axios from 'axios';
import router from '../router/router'
import { Message, Loading } from 'element-ui';
import store from '../store/store'
let baseURL = '';
// 测试地址
// baseURL = 'https://backend-api.aihuedu.com/';

// 正式地址
baseURL='https://appnew.chinanurse.cn';

let config = {
  baseURL: baseURL,
  timeout: 30000 //设置最大请求时间
}
const _axios = axios.create(config)

// 头部挂载token 每次请求都会带上token
_axios.interceptors.request.use(function (config) {
  config.headers.token = localStorage.getItem("Authorization");
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});


//封装post,get方法
const http = {
  get(url = '', params = {}) {
    return new Promise((resolve, reject) => {
      _axios({
        url,
        params,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        responseType: 'blob',
        method: 'GET'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        if (error.response.data.code == 401 && error.response.data.msg == '用户未登录或token已经失效！') {
          Message.error(error.response.data.msg);
          store.state.loading.close()
          store.commit('setLoading', null)
          localStorage.clear()
          router.push({ name: 'login' });
        }
        reject(error)
      })
    })
  },
  _get(url = '', params = {}) {
    return new Promise((resolve, reject) => {
      _axios({
        url,
        params,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        method: 'GET'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        if (error.response.data.code == 401 && error.response.data.msg == '用户未登录或token已经失效！') {
          Message.error(error.response.data.msg);
          store.state.loading.close()
          store.commit('setLoading', null)
          localStorage.clear()
          router.push({ name: 'login' });
        }
        reject(error)
      })
    })
  },
  post(url = '', params = {}) {
    return new Promise((resolve, reject) => {
      _axios({
        url,
        data: params,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        method: 'POST'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        if (error.response.data.code == 401 && error.response.data.msg == '用户未登录或token已经失效！') {
          Message.error(error.response.data.msg);
          store.state.loading.close()
          store.commit('setLoading', null)
          localStorage.clear()
          router.push({ name: 'login' });
        }
        reject(error)
      })
    })
  },
  // post上传formdata数据
  formDataPost(url = '', params = {}) {
    return new Promise((resolve, reject) => {
      _axios({
        url,
        data: params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        method: 'POST'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        if (error.response.data.code == 401 && error.response.data.msg == '用户未登录或token已经失效！') {
          Message.error(error.response.data.msg);
          store.state.loading.close()
          store.commit('setLoading', null)
          localStorage.clear()
          router.push({ name: 'login' });
        }
        reject(error)
      })
    })
  },
}


export default http;
